import React from 'react';
import logoSrc from '../../assets/logo.svg';

export const Logo: React.FC<{ className?: string }> = ({ className }) => (
    <img
        src={logoSrc}
        alt="Snapfy.ai"
        className={`${className} min-h-[32px] light-mode-invert`}
    />
);
